import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "CrossSellOffer" }
const _hoisted_2 = { class: "CrossSellOffer__confirmation" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "CrossSellOffer__confirmIcon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 24" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M5.5 12.4 9.6 16.5 18.8 7.5" })
  ])
], -1)
const _hoisted_4 = { class: "CrossSellOffer__confirmText" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", null, "Produkt dodany do koszyka", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 24" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "m6 6 12 12M18 6 6 18" })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "CrossSellOffer__body" }
const _hoisted_12 = { class: "CrossSellOffer__top" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "CrossSellOffer__shipping"
}
const _hoisted_15 = { class: "CrossSellOffer__shippingHead" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 7h11v9H3zM14 10h3.4L21 13.6V16h-7z" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "7",
    cy: "18",
    r: "1.7"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "18",
    cy: "18",
    r: "1.7"
  })
], -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "CrossSellOffer__shippingTrack" }
const _hoisted_20 = { class: "CrossSellOffer__shippingScale" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "0 zł", -1)
const _hoisted_22 = {
  key: 0,
  class: "CrossSellOffer__tabs",
  role: "tablist"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 1,
  class: "CrossSellOffer__error"
}
const _hoisted_25 = {
  key: 2,
  class: "CrossSellOffer__grid"
}
const _hoisted_26 = {
  key: 3,
  class: "CrossSellOffer__empty"
}
const _hoisted_27 = { class: "CrossSellOffer__footer" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M7 8V6a5 5 0 0 1 10 0v2M5.5 8.5h13l-1 11h-11z" })
], -1)
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "CrossSellDetails__inner" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m6 6 12 12M18 6 6 18" })
], -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "CrossSellDetails__gallery" }
const _hoisted_34 = { class: "CrossSellDetails__media" }
const _hoisted_35 = ["src", "alt"]
const _hoisted_36 = {
  key: 0,
  class: "CrossSellDetails__thumbs"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["src", "alt"]
const _hoisted_39 = { class: "CrossSellDetails__content" }
const _hoisted_40 = { class: "CrossSellOffer__badge" }
const _hoisted_41 = { class: "CrossSellDetails__price" }
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = {
  key: 0,
  class: "CrossSellDetails__saving"
}
const _hoisted_45 = ["for"]
const _hoisted_46 = { class: "CrossSellDetails__options" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { key: 0 }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 24" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5.5 12.4 9.6 16.5 18.8 7.5" })
], -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { class: "CrossSellDetails__qty" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = ["disabled"]
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { key: 2 }
const _hoisted_58 = ["innerHTML"]

import { computed, ref } from 'vue';
import SingleProductCrossSell from './SingleProductCrossSell.vue';


export default {
  __name: 'ProductCrossSell',
  props: {
    products: {
        type: Array,
        default: () => [],
    },
    sections: {
        type: Array,
        default: () => [],
    },
    rule: {
        type: Object,
        default: null,
    },
    sourceProduct: {
        type: Object,
        default: null,
    },
    freeShipping: {
        type: Object,
        default: null,
    },
    addProductsToCart: {
        type: Function,
        required: true,
    },
    processToCart: {
        type: Function,
        required: true,
    },
    closePopup: {
        type: Function,
        required: true,
    },
},
  setup(__props) {

const props = __props;



const activeSection = ref('all');
const activeProduct = ref(null);
const activeImage = ref('');
const selectedAttributes = ref({});
const detailQuantity = ref(1);
const addedKeys = ref({});
const loadingKeys = ref({});
const errorMessage = ref('');

const sectionsData = computed(() => (props.sections || []).filter((section) => section.products?.length));

const allProducts = computed(() => {
    if (!sectionsData.value.length) {
        return props.products || [];
    }

    const seen = {};
    return sectionsData.value.reduce((products, section) => {
        (section.products || []).forEach((product) => {
            if (!seen[product.id]) {
                seen[product.id] = true;
                products.push(product);
            }
        });

        return products;
    }, []);
});

const visibleProducts = computed(() => {
    if (activeSection.value === 'all') {
        return allProducts.value;
    }

    const section = sectionsData.value.find((item) => item.id === activeSection.value);
    return section?.products || [];
});

const hasTabs = computed(() => sectionsData.value.length > 1);

const currentRule = computed(() => props.rule || {});
const sourceProduct = computed(() => props.sourceProduct || {});
const currentPercent = computed(() => currentRule.value?.percent || activeProduct.value?.discount_percent || 0);
const displayTitle = computed(() => {
    const title = currentRule.value?.title || '';

    return title && title !== 'Dobierz produkty w rabacie' ? title : 'Dobierz coś do kompletu';
});
const displayDescription = computed(() => {
    const description = currentRule.value?.description || '';

    return description && description !== 'Te produkty zostaną przeliczone w koszyku zgodnie z aktywną promocją.'
        ? description
        : 'Wybraliśmy produkty, które najlepiej pasują do Twojego zamówienia. Rabat naliczy się automatycznie w koszyku.';
});
const ruleBadge = computed(() => {
    const percent = currentPercent.value;
    return percent ? `DRUGI PRODUKT -${percent}%` : currentRule.value?.label || 'PROMOCJA';
});
const freeShipping = computed(() => props.freeShipping || {});
const shippingProgressStyle = computed(() => ({
    width: `${Math.max(0, Math.min(100, Number(freeShipping.value?.progress_percent || 0)))}%`,
}));

const makeCartKey = (item) => `${item.id}:${item.variation_id || 'simple'}`;

const setLoading = (key, value) => {
    loadingKeys.value = {
        ...loadingKeys.value,
        [key]: value,
    };
};

const markAdded = (key, productId) => {
    addedKeys.value = {
        ...addedKeys.value,
        [key]: true,
        [`${productId}:product`]: true,
    };
};

const defaultVariation = (product) => {
    if (!product?.variations?.length) return null;

    return (
        product.variations.find((variation) => variation.id === product.default_variation_id) ||
        product.variations[0]
    );
};

const defaultAttributes = (product) => {
    const variation = defaultVariation(product);
    return variation?.attributes ? { ...variation.attributes } : {};
};

const openProduct = (product) => {
    activeProduct.value = product;
    activeImage.value = '';
    selectedAttributes.value = defaultAttributes(product);
    detailQuantity.value = 1;
    errorMessage.value = '';
};

const closeProduct = () => {
    activeProduct.value = null;
    activeImage.value = '';
    selectedAttributes.value = {};
    detailQuantity.value = 1;
};

const selectedDetailVariation = computed(() => {
    const product = activeProduct.value;
    if (!product?.variations?.length) return null;

    const groups = product.variation_attributes || [];
    return product.variations.find((variation) =>
        groups.every((group) => {
            const selectedValue = selectedAttributes.value[group.name] || '';
            const variationValue = variation.attributes?.[group.name] || '';

            return variationValue === '' || variationValue === selectedValue;
        }),
    );
});

const detailImage = computed(() => {
    const product = activeProduct.value;
    if (!product) return '';

    return (
        activeImage.value ||
        selectedDetailVariation.value?.thumb ||
        product.gallery?.[0] ||
        product.thumb ||
        ''
    );
});

const detailThumbnails = computed(() => {
    const product = activeProduct.value;
    if (!product) return [];

    const urls = [];
    const addUrl = (url) => {
        if (url && !urls.includes(url)) {
            urls.push(url);
        }
    };

    addUrl(selectedDetailVariation.value?.thumb);
    (product.gallery || []).forEach(addUrl);
    addUrl(product.thumb);
    (product.variations || []).forEach((variation) => addUrl(variation.thumb));

    return urls.slice(0, 6);
});

const detailImageIndex = computed(() => {
    const thumbnails = detailThumbnails.value;
    if (!thumbnails.length) return 0;

    const index = thumbnails.findIndex((thumb) => thumb === detailImage.value);
    return index >= 0 ? index : 0;
});

const visibleDetailThumbnails = computed(() => {
    const thumbnails = detailThumbnails.value;
    if (thumbnails.length <= 3) return thumbnails;

    const maxStart = Math.max(0, thumbnails.length - 3);
    const start = Math.min(Math.max(0, detailImageIndex.value - 1), maxStart);

    return thumbnails.slice(start, start + 3);
});

const selectDetailImage = (thumb) => {
    activeImage.value = thumb;
};

const moveDetailImage = (direction) => {
    const thumbnails = detailThumbnails.value;
    if (!thumbnails.length) return;

    const nextIndex = (detailImageIndex.value + direction + thumbnails.length) % thumbnails.length;
    activeImage.value = thumbnails[nextIndex];
};

const detailDiscountedPrice = computed(() => {
    const product = activeProduct.value;
    if (!product) return '';

    return selectedDetailVariation.value?.discounted_price_html || product.discounted_price_html;
});

const detailBasePrice = computed(() => {
    const product = activeProduct.value;
    if (!product) return '';

    return selectedDetailVariation.value?.price_html || product.price_html;
});

const detailSaving = computed(() => {
    const product = activeProduct.value;
    if (!product) return '';

    return selectedDetailVariation.value?.saving_text || product.saving_text;
});

const detailCartItem = computed(() => {
    const product = activeProduct.value;
    if (!product) return null;

    const item = {
        id: product.id,
        quantity: detailQuantity.value,
    };

    if (product.variations?.length) {
        const variation = selectedDetailVariation.value;
        if (!variation) return null;

        item.variation_id = variation.id;
        item.variation = variation.attributes || {};
    }

    return item;
});

const detailKey = computed(() => (detailCartItem.value ? makeCartKey(detailCartItem.value) : ''));
const isDetailLoading = computed(() => !!loadingKeys.value[detailKey.value]);
const isDetailAdded = computed(() => !!addedKeys.value[detailKey.value]);

const updateDetailAttribute = (name, value) => {
    selectedAttributes.value = {
        ...selectedAttributes.value,
        [name]: value,
    };
};

const selectDetailAttribute = (name, value) => {
    activeImage.value = '';
    updateDetailAttribute(name, value);
};

const addProduct = async ({ product, variation = null, quantity = 1, closeAfterAdd = false }) => {
    errorMessage.value = '';

    const cartItem = {
        id: product.id,
        quantity,
        bogo_rule_id: currentRule.value?.id || 0,
    };

    if (product.variations?.length) {
        if (!variation) {
            openProduct(product);
            errorMessage.value = 'Wybierz wariant produktu.';
            return;
        }

        cartItem.variation_id = variation.id;
        cartItem.variation = variation.attributes || {};
    }

    const key = makeCartKey(cartItem);
    setLoading(key, true);

    try {
        const response = await props.addProductsToCart([cartItem]);

        if (!response || response.success === false) {
            throw new Error(response?.data?.message || 'Nie udało się dodać produktu.');
        }

        markAdded(key, product.id);

        const errors = response?.data?.errors || [];
        if (errors.length) {
            errorMessage.value = errors.join(' ');
        }

        if (closeAfterAdd) {
            closeProduct();
        }
    } catch (error) {
        errorMessage.value = error?.message || 'Nie udało się dodać produktu.';
    } finally {
        setLoading(key, false);
    }
};

const addActiveProduct = () => {
    const product = activeProduct.value;
    const cartItem = detailCartItem.value;
    if (!product || !cartItem) {
        errorMessage.value = 'Wybierz dostępny wariant produktu.';
        return;
    }

    addProduct({
        product,
        variation: selectedDetailVariation.value,
        quantity: detailQuantity.value,
        closeAfterAdd: true,
    });
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_unref(sourceProduct)?.name)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_unref(sourceProduct).name), 1))
          : _createCommentVNode("", true),
        (_unref(sourceProduct)?.price_text)
          ? (_openBlock(), _createElementBlock("strong", _hoisted_7, _toDisplayString(_unref(sourceProduct).price_text), 1))
          : _createCommentVNode("", true)
      ]),
      (_unref(sourceProduct)?.thumb)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _unref(sourceProduct).thumb,
            alt: _unref(sourceProduct).name
          }, null, 8, _hoisted_8))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "Button--no-style CrossSellOffer__close",
        onClick: _cache[0] || (_cache[0] = (...args) => (__props.closePopup && __props.closePopup(...args))),
        "aria-label": "Zamknij"
      }, _hoisted_10)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", null, [
          _createElementVNode("h5", null, [
            _createTextVNode(_toDisplayString(_unref(displayTitle)) + " ", 1),
            (_unref(currentPercent))
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "- drugi produkt " + _toDisplayString(_unref(currentPercent)) + "% taniej", 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("p", null, _toDisplayString(_unref(displayDescription)), 1)
        ]),
        (_unref(freeShipping).enabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                (_unref(freeShipping).qualified)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, "Gratulacje! Otrzymujesz darmową dostawę!"))
                  : (_openBlock(), _createElementBlock("p", _hoisted_18, [
                      _createTextVNode(" Brakuje "),
                      _createElementVNode("strong", null, _toDisplayString(_unref(freeShipping).remaining_text), 1),
                      _createTextVNode(" do darmowej dostawy ")
                    ]))
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", {
                  style: _normalizeStyle(_unref(shippingProgressStyle))
                }, null, 4)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("span", null, _toDisplayString(_unref(freeShipping).threshold_text), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_unref(hasTabs))
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["Button--no-style", { active: activeSection.value === 'all' }]),
              onClick: _cache[1] || (_cache[1] = $event => (activeSection.value = 'all'))
            }, " Wszystkie ", 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sectionsData), (section) => {
              return (_openBlock(), _createElementBlock("button", {
                key: section.id,
                type: "button",
                class: _normalizeClass(["Button--no-style", { active: activeSection.value === section.id }]),
                onClick: $event => (activeSection.value = section.id)
              }, _toDisplayString(section.name), 11, _hoisted_23))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(errorMessage.value), 1))
        : _createCommentVNode("", true),
      (_unref(visibleProducts).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleProducts), (item) => {
              return (_openBlock(), _createBlock(SingleProductCrossSell, {
                key: item.id,
                item: item,
                "added-keys": addedKeys.value,
                "loading-keys": loadingKeys.value,
                "badge-label": _unref(ruleBadge),
                onOpenProduct: openProduct
              }, null, 8, ["item", "added-keys", "loading-keys", "badge-label"]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_26, " Aktualnie nie ma dostępnych produktów w tej promocji. "))
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("button", {
        type: "button",
        class: "Button Button--secondary CrossSellOffer__secondary",
        onClick: _cache[2] || (_cache[2] = (...args) => (__props.closePopup && __props.closePopup(...args)))
      }, " Kontynuuj zakupy "),
      _createElementVNode("button", {
        type: "button",
        class: "Button CrossSellOffer__primary",
        onClick: _cache[3] || (_cache[3] = $event => (__props.processToCart()))
      }, [
        _createTextVNode(" Przejdź do koszyka "),
        _hoisted_28
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (activeProduct.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "CrossSellDetails",
            role: "dialog",
            "aria-modal": "true",
            onClick: _withModifiers(closeProduct, ["self"])
          }, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("button", {
                type: "button",
                class: "Button--no-style CrossSellDetails__close",
                "aria-label": "Zamknij",
                onClick: closeProduct
              }, _hoisted_32),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("img", {
                    src: _unref(detailImage),
                    alt: activeProduct.value.name
                  }, null, 8, _hoisted_35)
                ]),
                (_unref(detailThumbnails).length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "Button--no-style CrossSellDetails__thumbNav CrossSellDetails__thumbNav--prev",
                        "aria-label": "Poprzednie zdjęcie",
                        onClick: _cache[4] || (_cache[4] = $event => (moveDetailImage(-1)))
                      }, " ‹ "),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleDetailThumbnails), (thumb) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: thumb,
                          type: "button",
                          class: _normalizeClass(["Button--no-style CrossSellDetails__thumb", { active: _unref(detailImage) === thumb }]),
                          onClick: $event => (selectDetailImage(thumb))
                        }, [
                          _createElementVNode("img", {
                            src: thumb,
                            alt: activeProduct.value.name
                          }, null, 8, _hoisted_38)
                        ], 10, _hoisted_37))
                      }), 128)),
                      _createElementVNode("button", {
                        type: "button",
                        class: "Button--no-style CrossSellDetails__thumbNav CrossSellDetails__thumbNav--next",
                        "aria-label": "Następne zdjęcie",
                        onClick: _cache[5] || (_cache[5] = $event => (moveDetailImage(1)))
                      }, " › ")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(ruleBadge)), 1),
                _createElementVNode("h4", null, _toDisplayString(activeProduct.value.name), 1),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("span", { innerHTML: _unref(detailDiscountedPrice) }, null, 8, _hoisted_42),
                  _createElementVNode("del", { innerHTML: _unref(detailBasePrice) }, null, 8, _hoisted_43)
                ]),
                (_unref(detailSaving))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_44, " Oszczędzasz " + _toDisplayString(_unref(detailSaving)), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeProduct.value.variation_attributes, (group) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: group.name,
                    class: "CrossSellDetails__field"
                  }, [
                    _createElementVNode("label", {
                      for: `cross-sell-${activeProduct.value.id}-${group.name}`
                    }, _toDisplayString(group.label), 9, _hoisted_45),
                    _createElementVNode("div", _hoisted_46, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (option) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: `${group.name}-${option.value}`,
                          type: "button",
                          class: _normalizeClass(["Button--no-style", { active: (selectedAttributes.value[group.name] || '') === option.value }]),
                          onClick: $event => (selectDetailAttribute(group.name, option.value))
                        }, [
                          _createTextVNode(_toDisplayString(option.label) + " ", 1),
                          ((selectedAttributes.value[group.name] || '') === option.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_48, _hoisted_50))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_47))
                      }), 128))
                    ])
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "Button--no-style",
                    disabled: detailQuantity.value <= 1,
                    onClick: _cache[6] || (_cache[6] = $event => (detailQuantity.value = Math.max(1, detailQuantity.value - 1)))
                  }, " - ", 8, _hoisted_52),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((detailQuantity).value = $event)),
                    type: "number",
                    min: "1",
                    max: "10"
                  }, null, 512), [
                    [
                      _vModelText,
                      detailQuantity.value,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "Button--no-style",
                    disabled: detailQuantity.value >= 10,
                    onClick: _cache[8] || (_cache[8] = $event => (detailQuantity.value = Math.min(10, detailQuantity.value + 1)))
                  }, " + ", 8, _hoisted_53)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "Button CrossSellDetails__add",
                  disabled: _unref(isDetailLoading) || !_unref(detailCartItem),
                  onClick: addActiveProduct
                }, [
                  (_unref(isDetailLoading))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_55, "Dodawanie..."))
                    : (_unref(isDetailAdded))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_56, "Dodano do koszyka"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_57, "Dodaj w rabacie"))
                ], 8, _hoisted_54),
                (activeProduct.value.description)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "CrossSellDetails__description",
                      innerHTML: activeProduct.value.description
                    }, null, 8, _hoisted_58))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 8, _hoisted_29))
        : _createCommentVNode("", true)
    ]))
  ]))
}
}

}